var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseOneThirds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    stroke: "#C4CED7",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4CED7",
    d: "M18.5 6a12.5 12.5 0 0 1 10.957 18.515L18.5 18.5V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseOneThirds);
export default __webpack_public_path__ + "static/media/ellipseOneThirds.edad99ce2784b2db198dba5411c3b557.svg";
export { ForwardRef as ReactComponent };